var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "ik-container",
    },
    [
      _c("el-header", { attrs: { height: "42px" } }, [
        _c("span", { staticClass: "ik-board-title" }, [
          _c("span", { staticClass: "logo" }),
          _vm._v(" 数据列表 "),
          _c("div", { staticClass: "time" }, [
            _c("span", [_vm._v("2024-04-28 21:28:00")]),
          ]),
        ]),
      ]),
      _c(
        "el-main",
        [
          _c(
            "el-row",
            { staticClass: "board-row", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                {
                  staticClass: "board-col",
                  staticStyle: { height: "150px" },
                  attrs: { span: 4 },
                },
                [
                  _c("ik-label-base", {
                    attrs: {
                      code: "2",
                      title: "税价合计",
                      "main-value": "1224.91",
                      "main-unit": "万",
                      data: [
                        { key: "同比", value: "12.91" },
                        { key: "环比", value: "14.51" },
                      ],
                      "data-dimension-field": "value",
                      "first-analysis-dimension-field": "key",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticClass: "board-col",
                  staticStyle: { height: "150px" },
                  attrs: { span: 4 },
                },
                [
                  _c("ik-label-base", {
                    attrs: {
                      code: "2",
                      title: "采购次数",
                      "main-value": "1262",
                      "main-unit": "",
                      data: [
                        { key: "同比", value: "12.91" },
                        { key: "环比", value: "14.51" },
                      ],
                      "data-dimension-field": "value",
                      "first-analysis-dimension-field": "key",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticClass: "board-col",
                  staticStyle: { height: "150px" },
                  attrs: { span: 4 },
                },
                [
                  _c("ik-label-base", {
                    attrs: {
                      code: "2",
                      title: "收货次数",
                      "main-value": "1221",
                      "main-unit": "",
                      data: [
                        { key: "同比", value: "12.91" },
                        { key: "环比", value: "14.51" },
                      ],
                      "data-dimension-field": "value",
                      "first-analysis-dimension-field": "key",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticClass: "board-col",
                  staticStyle: { height: "150px" },
                  attrs: { span: 4 },
                },
                [
                  _c("ik-label-base", {
                    attrs: {
                      code: "2",
                      title: "到货及时率",
                      "main-value": "96.82%",
                      "main-unit": "",
                      data: [
                        { key: "同比", value: "12.91" },
                        { key: "环比", value: "14.51" },
                      ],
                      "data-dimension-field": "value",
                      "first-analysis-dimension-field": "key",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticClass: "board-col",
                  staticStyle: { height: "150px" },
                  attrs: { span: 4 },
                },
                [
                  _c("ik-label-base", {
                    attrs: {
                      code: "2",
                      title: "到货合格率",
                      "main-value": "98.92%",
                      "main-unit": "",
                      data: [
                        { key: "同比", value: "12.91" },
                        { key: "环比", value: "14.51" },
                      ],
                      "data-dimension-field": "value",
                      "first-analysis-dimension-field": "key",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticClass: "board-col",
                  staticStyle: { height: "150px" },
                  attrs: { span: 4 },
                },
                [
                  _c("ik-label-base", {
                    attrs: {
                      code: "2",
                      title: "退货税价",
                      "main-value": "5.92",
                      "main-unit": "万",
                      data: [
                        { key: "同比", value: "12.91" },
                        { key: "环比", value: "14.51" },
                      ],
                      "data-dimension-field": "value",
                      "first-analysis-dimension-field": "key",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "board-row", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                {
                  staticClass: "board-col",
                  staticStyle: { height: "350px" },
                  attrs: { span: 8 },
                },
                [
                  _c("ik-bar-base-chart", {
                    attrs: {
                      code: "1-1",
                      title: "物料采购Top10",
                      data: [
                        { key: "物料1", value: "84.63" },
                        { key: "物料2", value: "81.72" },
                        { key: "物料3", value: "78.37" },
                        { key: "物料4", value: "73.42" },
                        { key: "物料5", value: "71.71" },
                        { key: "物料6", value: "68.10" },
                        { key: "物料7", value: "66.39" },
                        { key: "物料8", value: "64.03" },
                        { key: "物料9", value: "61.18" },
                        { key: "物料10", value: "60.35" },
                      ],
                      "data-dimension-field": "value",
                      "first-analysis-dimension-field": "key",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticClass: "board-col",
                  staticStyle: { height: "350px" },
                  attrs: { span: 8 },
                },
                [
                  _c("ik-bar-stack-chart", {
                    attrs: {
                      code: "1-2",
                      title: "财务主体ABC构成",
                      data: [
                        { area: "主体1", type: "A类", value: "84.63" },
                        { area: "主体1", type: "B类", value: "14.52" },
                        { area: "主体1", type: "C类", value: "4.64" },
                        { area: "主体2", type: "A类", value: "197.72" },
                        { area: "主体2", type: "B类", value: "27.34" },
                        { area: "主体2", type: "C类", value: "8.67" },
                        { area: "主体3", type: "A类", value: "251.24" },
                        { area: "主体3", type: "B类", value: "20.16" },
                        { area: "主体3", type: "C类", value: "9.98" },
                      ],
                      "data-dimension-field": "value",
                      "first-analysis-dimension-field": "area",
                      "second-analysis-dimension-field": "type",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticClass: "board-col",
                  staticStyle: { height: "350px" },
                  attrs: { span: 8 },
                },
                [
                  _c("ik-bar-base-chart", {
                    attrs: {
                      code: "1-3",
                      title: "供应商采购Top10",
                      data: [
                        { key: "供应商1", value: "84.63" },
                        { key: "供应商2", value: "81.72" },
                        { key: "供应商3", value: "78.37" },
                        { key: "供应商4", value: "73.42" },
                        { key: "供应商5", value: "71.71" },
                        { key: "供应商6", value: "68.10" },
                        { key: "供应商7", value: "66.39" },
                        { key: "供应商8", value: "64.03" },
                        { key: "供应商9", value: "61.18" },
                        { key: "供应商10", value: "60.35" },
                      ],
                      "data-dimension-field": "value",
                      "first-analysis-dimension-field": "key",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticClass: "board-col",
                  staticStyle: { height: "350px" },
                  attrs: { span: 6 },
                },
                [
                  _c("ik-pie-base-chart", {
                    attrs: {
                      code: "2-1",
                      title: "物料退货比例",
                      data: [
                        { key: "物料1", value: "1.63" },
                        { key: "物料2", value: "2.72" },
                        { key: "物料3", value: "1.37" },
                      ],
                      "data-dimension-field": "value",
                      "analysis-dimension-field": "key",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticClass: "board-col",
                  staticStyle: { height: "350px" },
                  attrs: { span: 12 },
                },
                [
                  _c("ik-line-time-chart", {
                    attrs: {
                      code: "2-2",
                      title: "采购时序",
                      data: [
                        {
                          type: "主体1",
                          time: "2024-01-01 00:00:00",
                          value: "72.97",
                        },
                        {
                          type: "主体2",
                          time: "2024-01-01 00:00:00",
                          value: "62.94",
                        },
                        {
                          type: "主体3",
                          time: "2024-01-01 00:00:00",
                          value: "87.75",
                        },
                        {
                          type: "主体4",
                          time: "2024-01-01 00:00:00",
                          value: "77.87",
                        },
                        {
                          type: "主体1",
                          time: "2024-02-01 00:00:00",
                          value: "39",
                        },
                        {
                          type: "主体2",
                          time: "2024-02-01 00:00:00",
                          value: "39",
                        },
                        {
                          type: "主体3",
                          time: "2024-02-01 00:00:00",
                          value: "39",
                        },
                        {
                          type: "主体4",
                          time: "2024-02-01 00:00:00",
                          value: "39",
                        },
                        {
                          type: "主体1",
                          time: "2024-03-01 00:00:00",
                          value: "39",
                        },
                        {
                          type: "主体2",
                          time: "2024-03-01 00:00:00",
                          value: "39",
                        },
                        {
                          type: "主体3",
                          time: "2024-03-01 00:00:00",
                          value: "39",
                        },
                        {
                          type: "主体4",
                          time: "2024-03-01 00:00:00",
                          value: "39",
                        },
                        {
                          type: "主体1",
                          time: "2024-04-01 00:00:00",
                          value: "39",
                        },
                        {
                          type: "主体2",
                          time: "2024-04-01 00:00:00",
                          value: "39",
                        },
                        {
                          type: "主体3",
                          time: "2024-04-01 00:00:00",
                          value: "39",
                        },
                        {
                          type: "主体4",
                          time: "2024-04-01 00:00:00",
                          value: "39",
                        },
                      ],
                      "time-dimension-start": "2024-01-01 00:00:00",
                      "time-dimension-end": "2024-04-01 00:00:00",
                      "time-dimension-uom": "month",
                      "time-dimension-field": "time",
                      "data-dimension-field": "value",
                      "analysis-dimension-field": "type",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticClass: "board-col",
                  staticStyle: { height: "350px" },
                  attrs: { span: 6 },
                },
                [
                  _c("ik-pie-base-chart", {
                    attrs: {
                      code: "2-3",
                      title: "供应商退货比例",
                      data: [
                        { key: "供应商1", value: "2.13" },
                        { key: "供应商2", value: "2.92" },
                        { key: "供应商3", value: "2.67" },
                        { key: "供应商4", value: "1.67" },
                      ],
                      "data-dimension-field": "value",
                      "analysis-dimension-field": "key",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-footer",
        { attrs: { height: "36px" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 0 } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "span",
                  {
                    staticClass: "ik-footer-info",
                    staticStyle: { float: "left" },
                  },
                  [_vm._v("底部标签")]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }